module.exports = __webpack_public_path__ + "img/icon-faq-photos.a3a03fe4.svg";